import React from 'react';
import { styled } from '@mui/material/styles';

const Container = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100vh', // Full viewport height
  backgroundColor: '#f0f0f0', // Light background color
  border: '2px solid #ccc', // Light gray border
  borderRadius: '8px', // Rounded corners
  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
  padding: '20px', // Add some padding
  boxSizing: 'border-box', // Include padding in width/height
});

const Iframe = styled('iframe')({
  width: '100%', // Full width
  height: '100%', // Full height
  border: 'none', // No border
  borderRadius: '8px', // Match the container’s rounded corners
});

const UnityGame = () => {
  return (
    <Container>
      <Iframe
        src={`/unity/index-pathfinder.html`}
        title="Unity WebGL Game"
        allowFullScreen
      ></Iframe>
    </Container>
  );
};

export default UnityGame;
